import { render, staticRenderFns } from "./sales-purchase.vue?vue&type=template&id=12e6af3d"
import script from "./sales-purchase.vue?vue&type=script&lang=js"
export * from "./sales-purchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports